.image {
    height: 100%;
    width: auto;
    max-width: var(--img-width);
    max-height: var(--img-height);
}
